/* eslint-disable import/no-anonymous-default-export */
import { setListedData } from "app/common/components/customFunction";
import get from "lodash/get";
import {
  ADD_EVIDENCE_JOB1,
  ADD_EVIDENCE_JOB_ERROR,
  ADD_EVIDENCE_JOB_SUCCESS,
  ALL_CYLINDER,
  ALL_RESET_JOB_ACTION,
  BRAND_OPTIONS_LIST,
  BRAND_PRODUCT_MODEL_DETAILS,
  BUILDING_ID,
  CONFIRMATION_EDIT_FLAG,
  CUSTOMER_ID,
  DEALER_JOB_FLAG,
  DISPLAY_TABLE_CYLINDER,
  EDIT_INFO, FILL_AC_CYLINDER, FILL_CAR_AC, FILL_OTHER_CYLINDER, FILL_RECOVERY_INDEX, FILL_REF_CYLINDER, FILL_TOOL,
  GETTING_ALL_JOBS,
  GET_ALL_JOBS_ERROR,
  GET_ALL_JOB_VIEW_DATA,
  GET_EVIDENCE_JOB_MIDDLEWARE,
  GET_JOB_ID,
  GET_UPDATE_API_DATA,
  ISSUE_DETAILS,
  JOB_DETAIL,
  JOB_FLAG,
  JOB_UPDATE_PAYLOAD,
  LANGUAGE_CHANGES,
  LOADER,
  LOADER_FLAG, MULTI_DEALER_ADD,
  MULTI_IMAGE,
  PAYLOAD_CONTRACTOR,
  PAYLOAD_DEALER,
  PAYLOAD_RECYCLE_FACTORY,
  PAYLOAD_TRANSPORT,
  RECOVERY_CAR_AC,
  RECOVERY_CAR_AC_CYLINDER,
  RECOVERY_CYLINDER_ARRAY,
  RECOVERY_CYLINDER_INDEX,
  RECOVERY_REFRIGERATOR_EQUIP,
  RECOVERY_REF_CYLINDER,
  RECOVERY_TOOL,
  REFRIGERATOR_EQUIP,
  RENTAL_EDIT_FLAG,
  RENTAL_JOB_TYPE,
  RENTAL_STATUS,
  RESET_JOB_ACTION,
  RESET_JOB_INIT_STATE,
  SEARCH_MY_JOBS_data,
  SELECT_BORROWED_DATA,
  SELECT_BUILDING_DATA,
  SELECT_CONTRACTOR_DATA,
  SELECT_CYLINDER_DATA,
  SELECT_DEALER_DATA,
  SELECT_DISPOSE_CONTRACTOR_DATA,
  SELECT_RECEIVER_DATA,
  SELECT_RECYCLE_FACTORY_DATA,
  SELECT_SENDER_DATA,
  SELECT_TRANSPORT_DATA,
  SET_100KG_TRANSFER_CYLINDER,
  SET_ACTIVE_JOB_TYPE,
  SET_ACTIVE_RENT_ARRANGE,
  SET_ALL_JOBS, SET_CONFIRMATION_REPORT,
  SET_CREATE_JOB,
  SET_CUSTOMER_BUILDING_UPDATE,
  SET_DEFAULT_CAPACITY_VALUE,
  SET_EQUIPMENT_DETAIL_FLAG,
  SET_FILL_RECOVERY_TYPE,
  SET_FILTERED_CONTRACTOR,
  SET_FISCAL_YEAR_LIST,
  SET_JOB_SEARCH_VALUE,
  SET_JOB_STATUS, SET_LOT_LIST, SET_MESSAGE_DATA,
  SET_MULTI_SELECTED_CYLINDER,
  SET_NOTIFICATION_JOB,
  SET_OWNED_BORROWED_CYLINDER,
  SET_QR_CYLINDER_DATA,
  SET_QR_CYLINDER_VALIDATION,
  SET_QR_RESULT_DATA,
  SET_QUICK_LINK_TYPE,
  SET_RECEPTION_CYLINDER_DATA,
  SET_REVIEW,
  SET_SCANNER_TYPE,
  SET_SEARCH_USER,
  SET_SINGLE_JOB,
  SET_UPDATED_JOB_EQUIPMENT_DETAIL,
  SET_UPDATE_HISTORY, SHOW_LIST_FLAG,
  TRANSPORT_DATA_LIST,
  TRANSPORT_SEND_RETURN,
  UPDATE_FLAG,
  UPDATE_JOB_SUCCESS
} from "./types";

const initialState = {
  loader: false,
  jobFlagValue: false,
  dealerFlag: false,
  showList: false,
  searchMyJobData: {},
  multiDealerList: [],
  confirmationEditFlag: false,
  jobCustomerId: "",
  jobBuildingId: "",
  rentalType: "",
  brandDropdownList: {},
  fillRecoveryType: { listType: "" },
  brandProductModelData: {},
  equipmentDetailFlag: true,
  updatedJobEquipmentData: { systemId: "", listName: "", index: "" },
  fillRecoveryFormIndex: 0,
  recoveryCylinderIndex: 0,
  recoveryCylinderArray: [],
  createJob: {},
  capacityValue: "",
  quickLinkType: "",
  jobType: "",
  jobStatus: "",
  jobTypeDetail: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    activeFillLastPage: 1,
    isUpdate: false,
  },
  allJobs: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
  },
  filteredContractor: {},
  selectedJob: {},
  jobReview: [],
  notificationJob: {
    loading: false,
    isError: false,
    errMsg: "",
    data: {},
  },
  selectSenderData: {},
  selectReceiverData: {},
  jobEvidence: {},
  apiCalledSuccessfully: false,
  success: false,
  languageChanges: false,
  jobDetail: { status: "", tab: "", },
  searchUserResult: {},
  qrCylinderSearch: { valid: false, response: {}, type: "" },
  qrResult: "",
  confirmationReport: {},
  updatedCustomerBuilding: {},
  ownedBorrowedCylinder: { ownedCylinder: [], borrowedCylinder: [], kg100Cylinder: [], borrowed100kgCylinder: [], allCylinder: [] },
  selectCylinderData: [],
  receptionStatusCylinder: [],
  selectedMultiCylinderData: [],
  TransferCylinder100KG: [],
  selectTransportData: {},
  selectDealerData: {},
  selectContractorData: {},
  selectRecycleFactoryData: {},
  selectedDisposeContractorData: [],
  transportSendReturn: { send: {}, return: {} },
  transportDataList: {},
  selectBuildingData: [],
  selectBorrowedData: {},
  allCylinder: {},
  displayCylinder: [],
  carAcCylinder: [],
  recoveryRefCylinder: [],
  fillACCylinderList: [],
  fillRefCylinderList: [],
  fillOtherCylinderList: [],

  payloadDealer: {},
  payloadContractor: {},
  payloadRecycleFactory: {},
  payloadTransport: {},

  fillTool: [],
  recoveryTool: [],
  toolRefrigerator: [],
  recoveryRefrigerator: [],
  fillCarAc: [],
  recoveryCarAc: [],
  multiImage: {
    tool: [],
    refrigeratorEquipment: [],
    recoveryTool: [],
    recoveryRefrigeratorEquipment: [],
  },
  allJobViewData: {},
  JobPayload: [],
  jobId: "",
  getUpdateApiData: {},
  updateFlag: false,
  rentalEditFlag: false,
  rentalStatus: "",
  editInfoData: {},
  updateHistoryData: {},
  messageData: { modal: false, message: [], onlyOkBtnFooter: false },
  fiscalYearList: [],
  jobSearch: {
    searchTagValue: {},
    search: ''
  },
  lotData: { list: [], selected: null },
  issueData: { isOpen: false, details: {} }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GETTING_ALL_JOBS:
      return {
        ...state,
        allJobs: { ...state.allJobs, loading: true },
      };
    case ISSUE_DETAILS:
      return {
        ...state,
        issueData: action.payload,
      };
    case SET_FISCAL_YEAR_LIST:
      return {
        ...state,
        fiscalYearList: action.payload,
      };

    case JOB_FLAG:
      return {
        ...state,
        jobFlagValue: action.payload,
      };
    case DEALER_JOB_FLAG:
      return {
        ...state,
        dealerFlag: action.payload,
      };

    case MULTI_DEALER_ADD:
      return {
        ...state,
        multiDealerList: action.payload,
      };
    case EDIT_INFO:
      return {
        ...state,
        editInfoData: action.payload,
      };
    case SET_DEFAULT_CAPACITY_VALUE:
      return {
        ...state,
        capacityValue: action.payload,
      }
    case FILL_RECOVERY_INDEX:
      return {
        ...state,
        fillRecoveryFormIndex: action.payload,
      };
    case RECOVERY_CYLINDER_INDEX:
      return {
        ...state,
        recoveryCylinderIndex: action.payload,
      };
    case RENTAL_STATUS:
      return {
        ...state,
        rentalStatus: action.payload,
      };
    case RENTAL_EDIT_FLAG:
      return {
        ...state,
        rentalEditFlag: action.payload,
      };
    case SET_ALL_JOBS:
      const allJobsList = get(action.payload, "list", []);
      const lastPage = get(action.payload, "lastPage", 1);
      const requestedPage = get(action.payload, "requestedPage", 1);
      const tableData = allJobsList.map((job) => ({
        ...job,
        // name: `${admin.firstName} `,
        // creationDate: moment(admin.creationDate).format("DD/MM/YYYY"),
      }));

      const allData =
        // requestedPage === 1
        //     ?
        tableData;
      // : [...state.allJobs.data, ...tableData];

      return {
        ...state,
        allJobs: {
          ...state.allJobs,
          loading: false,
          data: allData,
          lastPage: lastPage,
        },
      };
    case GET_ALL_JOBS_ERROR:
      return {
        ...state,
        allJobs: { ...state.allJobs, loading: false },
      };
    case SET_ACTIVE_JOB_TYPE:
      return {
        ...state,
        jobType: action.payload,
      };
    case SET_JOB_STATUS:
      return {
        ...state,
        jobStatus: action.payload,
      };
    case UPDATE_JOB_SUCCESS:
      let prevData = [...state.allJobs.data];
      const toRemove = get(action.payload, "index.remove", false);
      const rowJobId = get(action.payload, "index.rowJobId", "");
      const type = get(action.payload, "type", false);

      const jobIndexToUpdate = prevData.findIndex(
        (job) => job.jobId === rowJobId
      );
      if (jobIndexToUpdate !== -1) {
        if (toRemove) {
          prevData.splice(jobIndexToUpdate, 1);
        } else if (toRemove === false) {
          prevData = prevData.map((job, jobIndex) => {
            if (jobIndex !== jobIndexToUpdate) return job;
            else {
              job.status = type;
              return job;
            }
          });
        }
      }
      return {
        ...state,
        allJobs: { ...state.allJobs, data: prevData },
      };
    case SET_NOTIFICATION_JOB:
      return {
        ...state,
        notificationJob: {
          ...state.notificationJob,
          data: action.payload,
        },
      };

    case ADD_EVIDENCE_JOB1:
      return {
        ...state,
        apiCalledSuccessfully: true,
      };
    case ADD_EVIDENCE_JOB_ERROR:
      return {
        ...state,
        success: false,
      };
    case ADD_EVIDENCE_JOB_SUCCESS:
      return {
        ...state,
        success: true,
      };
    case GET_EVIDENCE_JOB_MIDDLEWARE:
      return {
        ...state,
        apiCalledSuccessfully: false,
        jobEvidence: action.payload,
      };
    case LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case LANGUAGE_CHANGES:
      return {
        ...state,
        languageChanges: true,
      };

    case SET_ACTIVE_RENT_ARRANGE:
      const allActiveRentArrange = get(action.payload, "list", []);
      const activeRentArrangeLastPages = get(action.payload, "lastPage", 1);
      const nextCursor = get(action.payload, "nextCursor", null);
      const hasMorePages = nextCursor != null && nextCursor !== "";

      return {
        ...state,
        jobTypeDetail: {
          ...state.jobTypeDetail,
          loading: false,
          data: allActiveRentArrange,
          lastPage: activeRentArrangeLastPages,
          hasMore: hasMorePages,
          nextCursor,
          currentPage: get(action.payload, "currentPage", 1),
          cursorQueryKey: get(action.payload, "cursorQueryKey", null),
          pageCursors: get(action.payload, "pageCursors", {}),
        },
      };  

    case JOB_DETAIL:
      return {
        ...state,
        jobDetail: {
          status: action.status,
          tab: action.tab,
        },
      };

    case SET_CREATE_JOB:
      return {
        ...state,
        createJob: action.payload,
      };

    case SELECT_SENDER_DATA:
      return {
        ...state,
        selectSenderData: action.payload,
      };
    case RENTAL_JOB_TYPE:
      return {
        ...state,
        rentalType: action.payload,
      };
    case SELECT_RECEIVER_DATA:
      return {
        ...state,
        selectReceiverData: action.payload,
      };

    case SELECT_DEALER_DATA:
      return {
        ...state,
        selectDealerData: action.payload,
      };

    case SELECT_CONTRACTOR_DATA:
      return {
        ...state,
        selectContractorData: action.payload,
      };

    case SELECT_RECYCLE_FACTORY_DATA:
      return {
        ...state,
        selectRecycleFactoryData: action.payload,
      };

    case SELECT_DISPOSE_CONTRACTOR_DATA:
      return {
        ...state,
        selectedDisposeContractorData: action.payload,
      };

    case SELECT_TRANSPORT_DATA:
      return {
        ...state,
        selectTransportData: action.payload,
      };
    case SELECT_BUILDING_DATA:
      return {
        ...state,
        selectBuildingData: action.payload,
      };
    case TRANSPORT_DATA_LIST:
      return {
        ...state,
        transportDataList: action.payload,
      };

    case SELECT_CYLINDER_DATA:
      return {
        ...state,
        selectCylinderData: action.payload,
      };

    case SET_RECEPTION_CYLINDER_DATA:
      return {
        ...state,
        receptionStatusCylinder: action.payload,
      };

    case ALL_CYLINDER:
      return {
        ...state,
        allCylinder: action.payload,
      };

    case DISPLAY_TABLE_CYLINDER:
      return {
        ...state,
        displayCylinder: action.payload,
      };
    case RECOVERY_CAR_AC_CYLINDER:
      return {
        ...state,
        carAcCylinder: action.payload,
      };

    case SELECT_BORROWED_DATA:
      return {
        ...state,
        selectBorrowedData: action.payload,
      };

    case PAYLOAD_DEALER:
      return {
        ...state,
        payloadDealer: action.payload,
      };
    case PAYLOAD_CONTRACTOR:
      return {
        ...state,
        payloadContractor: action.payload,
      };
    case PAYLOAD_RECYCLE_FACTORY:
      return {
        ...state,
        payloadRecycleFactory: action.payload,
      };
    case PAYLOAD_TRANSPORT:
      return {
        ...state,
        payloadTransport: action.payload,
      };
    case FILL_TOOL:
      return {
        ...state,
        fillTool: action.payload,
      };
    case RECOVERY_TOOL:
      return {
        ...state,
        recoveryTool: action.payload,
      };
    case REFRIGERATOR_EQUIP:
      return {
        ...state,
        toolRefrigerator: action.payload,
      };
    case RECOVERY_REFRIGERATOR_EQUIP:
      return {
        ...state,
        recoveryRefrigerator: action.payload,
      };
    case FILL_CAR_AC:
      return {
        ...state,
        fillCarAc: action.payload,
      };
    case RECOVERY_CAR_AC:
      return {
        ...state,
        recoveryCarAc: action.payload,
      };
    case RECOVERY_REF_CYLINDER:
      return {
        ...state,
        recoveryRefCylinder: action.payload,
      };

    case MULTI_IMAGE:
      const tools = action.payload.tool;
      const refrigeratorEquipments = action.payload.refrigeratorEquipment;
      const recoveryTools = action?.payload?.recoveryTool;
      const recoveryRefrigeratorEquipments =
        action?.payload?.recoveryRefrigeratorEquipment;

      return {
        ...state,
        multiImage: {
          ...state.multiImage,
          tool: tools,
          refrigeratorEquipment: refrigeratorEquipments,
          recoveryTool: recoveryTools,
          recoveryRefrigeratorEquipment: recoveryRefrigeratorEquipments,
        },
      };

    case GET_ALL_JOB_VIEW_DATA:
      return {
        ...state,
        allJobViewData: action.payload,
      };

    case JOB_UPDATE_PAYLOAD:
      return {
        ...state,
        JobPayload: action.payload,
      };
    case GET_JOB_ID:
      return {
        ...state,
        jobId: action.payload,
      };
    case SET_SINGLE_JOB:
      return {
        ...state,
        selectedJob: action.payload,
      };
    case GET_UPDATE_API_DATA:
      return {
        ...state,
        getUpdateApiData: action.payload,
      };
    case UPDATE_FLAG:
      return {
        ...state,
        updateFlag: action.payload,
      };

    case RESET_JOB_INIT_STATE:
      return {
        state: { ...action.payload },
      };

    case SET_QR_CYLINDER_VALIDATION:
      // console.log(`valid flag.........`, action.payload);
      return {
        ...state,
        qrCylinderSearch: { ...state.qrCylinderSearch, valid: action.payload },
      };

    case SET_QR_CYLINDER_DATA:
      // console.log(`set respose.....`, action.payload);
      return {
        ...state,
        qrCylinderSearch: {
          ...state.qrCylinderSearch,
          response: action.payload,
        },
      };
    case SET_SCANNER_TYPE:
      // console.log(`set type.....`, action.payload);
      return {
        ...state,
        qrCylinderSearch: { ...state.qrCylinderSearch, type: action.payload },
      };

    case RECOVERY_CYLINDER_ARRAY:
      return {
        ...state,
        recoveryCylinderArray: action.payload,
      };

    case SET_QR_RESULT_DATA:
      return {
        ...state,
        qrResult: action.payload,
      };

    case SET_QUICK_LINK_TYPE:
      return {
        ...state,
        quickLinkType: action.payload,
      };

    case SET_CUSTOMER_BUILDING_UPDATE:
      return {
        ...state,
        updatedCustomerBuilding: action.payload,
      };

    case SET_FILTERED_CONTRACTOR:
      return {
        ...state,
        filteredContractor: action.payload,
      };

    case SET_SEARCH_USER:
      return {
        ...state,
        searchUserResult: action.payload,
      };

    case SET_MULTI_SELECTED_CYLINDER:
      return {
        ...state,
        selectedMultiCylinderData: action.payload,
      };

    case SET_100KG_TRANSFER_CYLINDER:
      return {
        ...state,
        TransferCylinder100KG: action.payload,
      };

    case SET_REVIEW:
      return {
        ...state,
        jobReview: action.payload,
      };
    case CUSTOMER_ID:
      return {
        ...state,
        jobCustomerId: action.payload,
      };
    case BUILDING_ID:
      return {
        ...state,
        jobBuildingId: action.payload,
      };

    case BRAND_OPTIONS_LIST:
      return {
        ...state,
        brandDropdownList: action.payload,
      };
    case SET_FILL_RECOVERY_TYPE:
      return {
        ...state,
        fillRecoveryType: action.payload,
      };
    case BRAND_PRODUCT_MODEL_DETAILS:
      return {
        ...state,
        brandProductModelData: action.payload,
      };

    case TRANSPORT_SEND_RETURN:
      let data = {}
      if (action.payload.type === "send") {
        data = { ...state.transportSendReturn, send: action.payload?.data }
      } else if (action.payload.type === "return") {
        data = { ...state.transportSendReturn, return: action.payload?.data }
      } else {
        data = action.payload.data
      }
      return {
        ...state,
        transportSendReturn: data,
      };

    case SET_OWNED_BORROWED_CYLINDER:
      let cylinders = {}
      if (action.payload?.ownedCylinder) {
        const dataList = setListedData({ data: state.ownedBorrowedCylinder.allCylinder, newList: action.payload?.ownedCylinder })
        cylinders = { ...state.ownedBorrowedCylinder, allCylinder: dataList, ownedCylinder: action.payload?.ownedCylinder }
      } else if (action.payload?.borrowedCylinder) {
        const dataList = setListedData({ data: state.ownedBorrowedCylinder.allCylinder, newList: action.payload?.borrowedCylinder })
        cylinders = { ...state.ownedBorrowedCylinder, allCylinder: dataList, borrowedCylinder: action.payload?.borrowedCylinder }
      } else if (action.payload?.kg100Cylinder) {
        const dataList = setListedData({ data: state.ownedBorrowedCylinder.allCylinder, newList: action.payload?.kg100Cylinder })
        cylinders = { ...state.ownedBorrowedCylinder, allCylinder: dataList, kg100Cylinder: action.payload?.kg100Cylinder }
      } else if (action.payload?.borrowed100kgCylinder) {
        const dataList = setListedData({ data: state.ownedBorrowedCylinder.allCylinder, newList: action.payload?.borrowed100kgCylinder })
        cylinders = { ...state.ownedBorrowedCylinder, allCylinder: dataList, borrowed100kgCylinder: action.payload?.borrowed100kgCylinder }
      } else if (action.payload?.allCylinder) {
        cylinders = { ...state.ownedBorrowedCylinder, allCylinder: action.payload?.allCylinder }
      }
      return {
        ...state,
        ownedBorrowedCylinder: cylinders,
      };

    case RESET_JOB_ACTION:
      return {
        ...state, ...action.payload
      };

    case SET_EQUIPMENT_DETAIL_FLAG:
      return {
        ...state,
        equipmentDetailFlag: action.payload
      };
    case SEARCH_MY_JOBS_data:
      return {
        ...state,
        searchMyJobData: action.payload
      };

    case SET_UPDATED_JOB_EQUIPMENT_DETAIL:
      return {
        ...state,
        updatedJobEquipmentData: action.payload
      };
    case LOADER_FLAG:
      return {
        ...state,
        loader: action.payload
      };
    case SHOW_LIST_FLAG:
      return {
        ...state,
        showList: action.payload,
      };

    case CONFIRMATION_EDIT_FLAG:
      return {
        ...state,
        confirmationEditFlag: action.payload
      };

    case SET_MESSAGE_DATA:
      return {
        ...state,
        messageData: action.payload
      };

    case SET_UPDATE_HISTORY:
      return {
        ...state,
        updateHistoryData: action.payload,
      };

    case SET_CONFIRMATION_REPORT:
      return {
        ...state,
        confirmationReport: action?.payload,
      };

    case SET_JOB_SEARCH_VALUE:
      return {
        ...state,
        jobSearch: action?.payload,
      };
    case SET_LOT_LIST:
      return {
        ...state,
        lotData: { ...state?.lotData, ...action?.payload },
      };

    case FILL_AC_CYLINDER:
      return {
        ...state,
        fillACCylinderList: action.payload,
      };

    case FILL_REF_CYLINDER:
      return {
        ...state,
        fillRefCylinderList: action.payload,
      };

    case FILL_OTHER_CYLINDER:
      return {
        ...state,
        fillOtherCylinderList: action.payload,
      };

    case ALL_RESET_JOB_ACTION:
      return initialState


    default:
      return { ...state };
  }
};
